import { render, staticRenderFns } from "./prizeCenter.vue?vue&type=template&id=c0d1b25e&scoped=true"
import script from "./prizeCenter.vue?vue&type=script&lang=js"
export * from "./prizeCenter.vue?vue&type=script&lang=js"
import style0 from "./prizeCenter.vue?vue&type=style&index=0&id=c0d1b25e&prod&scoped=true&lang=scss"
import style1 from "./prizeCenter.vue?vue&type=style&index=1&id=c0d1b25e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d1b25e",
  null
  
)

export default component.exports